module.exports = __webpack_public_path__ + "img/AT.dd9515ba.svg";